(() => {
  if (window.netlineQuickAddReady) return;
  window.netlineQuickAddReady = true;
  const productCache = new Map();
  let activeTrigger;

  const productJsonUrl = (productUrl) => {
    const url = new URL(productUrl, window.location.origin);
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    url.search = '';
    return url.toString();
  };

  const imageSource = (image) => {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || '';
  };

  const formatMoney = (amount, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(Number(amount || 0) / 100);
    } catch (error) {
      return `${currency} ${(Number(amount || 0) / 100).toFixed(2)}`;
    }
  };

  const dialog = document.createElement('dialog');
  dialog.className = 'nl-quick-dialog';
  dialog.setAttribute('aria-labelledby', 'NetlineQuickDialogTitle');
  dialog.innerHTML = '<div class="nl-quick-dialog__panel" data-quick-panel><header class="nl-quick-dialog__header"><div><p class="nl-kicker" data-quick-brand></p><strong id="NetlineQuickDialogTitle" data-quick-heading></strong></div><button type="button" data-quick-close>×</button></header><div class="nl-quick-dialog__body"><div class="nl-quick-dialog__media"><img data-quick-image alt=""></div><div class="nl-quick-dialog__content"><h2 data-quick-title></h2><p class="nl-quick-dialog__price" data-quick-price></p><div class="nl-quick-dialog__options" data-quick-options></div><form action="/cart/add" method="post" class="nl-quick-dialog__form" data-quick-form><input type="hidden" name="quantity" value="1"><input type="hidden" name="id" data-quick-variant><buy-button><button type="submit" class="nl-button nl-button--dark" data-quick-submit></button></buy-button></form><p class="nl-quick-dialog__message" data-quick-message hidden></p></div></div></div>';
  document.body.append(dialog);

  const panel = dialog.querySelector('[data-quick-panel]');
  const heading = dialog.querySelector('[data-quick-heading]');
  const brand = dialog.querySelector('[data-quick-brand]');
  const title = dialog.querySelector('[data-quick-title]');
  const image = dialog.querySelector('[data-quick-image]');
  const price = dialog.querySelector('[data-quick-price]');
  const optionsArea = dialog.querySelector('[data-quick-options]');
  const variantInput = dialog.querySelector('[data-quick-variant]');
  const submit = dialog.querySelector('[data-quick-submit]');
  const message = dialog.querySelector('[data-quick-message]');

  const closeDialog = () => {
    if (dialog.open) dialog.close();
  };

  dialog.querySelector('[data-quick-close]').addEventListener('click', closeDialog);
  dialog.addEventListener('click', (event) => {
    if (!panel.contains(event.target)) closeDialog();
  });
  dialog.addEventListener('close', () => activeTrigger?.focus());

  const normaliseOptions = (product) => (product.options || []).map((option, index) => {
    const values = [...new Set((product.variants || []).map((variant) => variant.options[index]).filter(Boolean))];
    if (typeof option === 'string') return { name: option, position: index + 1, values };
    return { name: option.name || `Option ${index + 1}`, position: option.position || index + 1, values: option.values || values };
  });

  const renderProduct = (product, trigger) => {
    const variants = product.variants || [];
    let selectedVariant = variants.find((variant) => variant.available) || variants[0];
    let selectedOptions = [...(selectedVariant?.options || [])];
    const currency = trigger.dataset.currency || 'GBP';
    const optionControls = [];

    heading.textContent = trigger.dataset.dialogLabel;
    brand.textContent = trigger.dataset.productBrand;
    title.textContent = product.title || trigger.dataset.productTitle;
    image.src = imageSource(selectedVariant?.featured_image) || imageSource(product.featured_image) || trigger.dataset.productImage;
    image.alt = product.title || trigger.dataset.productTitle;
    optionsArea.replaceChildren();
    message.hidden = true;

    normaliseOptions(product).forEach((option, index) => {
      if (/^(title|ships?[- ]?from|vendor|brand)$/i.test(option.name)) return;
      const label = document.createElement('label');
      const labelText = document.createElement('span');
      const select = document.createElement('select');
      labelText.textContent = option.name;
      select.setAttribute('aria-label', option.name);
      option.values.forEach((value) => {
        const choice = document.createElement('option');
        choice.value = value;
        choice.textContent = value;
        select.append(choice);
      });
      select.value = selectedOptions[index] || option.values[0] || '';
      label.append(labelText, select);
      optionsArea.append(label);
      optionControls.push({ index, select });
    });

    const syncVariant = (changedIndex) => {
      selectedVariant = variants.find((variant) => variant.options.every((value, index) => value === selectedOptions[index]));
      if (!selectedVariant && Number.isInteger(changedIndex)) {
        selectedVariant = variants.find((variant) => variant.available && variant.options[changedIndex] === selectedOptions[changedIndex]);
        if (selectedVariant) selectedOptions = [...selectedVariant.options];
      }
      optionControls.forEach(({ index, select }) => { select.value = selectedOptions[index] || ''; });
      if (selectedVariant) {
        variantInput.value = selectedVariant.id;
        price.textContent = formatMoney(selectedVariant.price, currency);
        const variantImage = imageSource(selectedVariant.featured_image);
        if (variantImage) image.src = variantImage;
      }
      submit.disabled = !selectedVariant?.available;
      submit.textContent = selectedVariant?.available ? trigger.dataset.addLabel : trigger.dataset.unavailableLabel;
    };

    optionControls.forEach(({ index, select }) => select.addEventListener('change', () => {
      selectedOptions[index] = select.value;
      syncVariant(index);
    }));
    syncVariant();
    dialog.classList.remove('is-loading');
  };

  const openQuickAdd = async (trigger) => {
    activeTrigger = trigger;
    dialog.classList.add('is-loading');
    heading.textContent = trigger.dataset.dialogLabel;
    brand.textContent = trigger.dataset.productBrand;
    title.textContent = trigger.dataset.productTitle;
    image.src = trigger.dataset.productImage;
    image.alt = trigger.dataset.productTitle;
    price.textContent = '';
    optionsArea.replaceChildren();
    submit.disabled = true;
    submit.textContent = trigger.dataset.addLabel;
    dialog.querySelector('[data-quick-close]').setAttribute('aria-label', trigger.dataset.closeLabel);
    if (!dialog.open) dialog.showModal();

    try {
      const url = productJsonUrl(trigger.dataset.productUrl);
      if (!productCache.has(url)) {
        productCache.set(url, fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((response) => {
          if (!response.ok) throw new Error('Product options unavailable');
          return response.json();
        }));
      }
      renderProduct(await productCache.get(url), trigger);
    } catch (error) {
      window.location.assign(trigger.dataset.productUrl);
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-netline-quick-add]');
    if (trigger) openQuickAdd(trigger);
  });

  document.addEventListener('product:added', (event) => {
    if (!event.detail?.productAdded) return;
    const button = event.detail.button;
    if (dialog.contains(button) && activeTrigger) {
      const label = activeTrigger.querySelector('.nl-card__quick-main');
      const defaultLabel = label?.textContent;
      if (label) label.textContent = activeTrigger.dataset.addedLabel;
      closeDialog();
      window.setTimeout(() => { if (label) label.textContent = defaultLabel; }, 1800);
    }
    if (button?.matches('[data-netline-card-direct]')) {
      const label = button.querySelector('.nl-card__quick-main');
      if (label) label.textContent = button.dataset.addedLabel;
      window.setTimeout(() => { if (label) label.textContent = button.dataset.defaultLabel; }, 1800);
    }
  });
})();
